import React, { Suspense, lazy } from 'react';
import { B } from '../constants';
import { borderRadius } from '../designTokens';
import FallbackImg from './FallbackImg';
import { categoryLabel } from './PlaceSheet';

const MapView = lazy(() => import('./MapView'));

export function PlaceCards({ places, onOpen, onHover }) {
  return (
    <div className="gb-chat-cards" style={{ display: 'flex', gap: 10, overflowX: 'auto', marginTop: 12, paddingBottom: 4, scrollSnapType: 'x mandatory' }}>
      {places.map((p, i) => (
        <button key={p.id} type="button" onClick={() => onOpen(p)}
          onMouseEnter={() => onHover(p)} onMouseLeave={() => onHover(null)} onFocus={() => onHover(p)}
          aria-label={`${p.name}, ${categoryLabel(p.category)}`}
          style={{
            flex: '0 0 150px', scrollSnapAlign: 'start', textAlign: 'left', padding: 0, cursor: 'pointer',
            background: '#fff', border: '1px solid #e7e2d9', borderRadius: 14, overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(15,25,35,0.06)', fontFamily: "'Montserrat',sans-serif",
          }}>
          <div style={{ position: 'relative', height: 92, background: '#e9efe9' }}>
            {p.imageUrl && (
              <FallbackImg sources={[p.imageUrl]} alt="" loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            )}
            <span style={{
              position: 'absolute', top: 6, left: 6, width: 22, height: 22, borderRadius: '50%',
              background: B.forest, color: '#fff', fontSize: 11, fontWeight: 800,
              display: 'grid', placeItems: 'center', border: '2px solid #fff',
            }}>{i + 1}</span>
          </div>
          <div style={{ padding: '8px 10px 10px' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: B.night, lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.name}</div>
            <div style={{ fontSize: 11, color: B.muted, marginTop: 3 }}>{categoryLabel(p.category)}</div>
          </div>
        </button>
      ))}
    </div>
  );
}

export function PlacesMap({ city, places, hovered, onSelect, height }) {
  const locations = places.map((p, i) => ({
    id: p.id, lat: p.lat, lng: p.lng, name: p.name, photoUrl: p.imageUrl || '', label: i + 1,
  }));
  return (
    <div style={{ background: '#fff', border: '1px solid #e7e2d9', borderRadius: borderRadius.lg, overflow: 'hidden', boxShadow: '0 6px 20px rgba(15,25,35,0.10)' }}>
      <div style={{ padding: '12px 16px', fontSize: 13, fontWeight: 700, color: B.night, fontFamily: "'Montserrat',sans-serif" }}>
        📍 {places.length} verified {places.length === 1 ? 'place' : 'places'}{city ? ` in ${city.name}` : ''}
      </div>
      <Suspense fallback={<div style={{ height }} />}>
        <MapView locations={locations} height={height} showRoute={false}
          hoveredActivity={hovered ? { title: hovered.name } : null}
          onActivityHover={(m) => onSelect(places.find((p) => p.id === m.id) || null)} />
      </Suspense>
    </div>
  );
}
